export default function initMosaicLazyLoading() {
  // fallback and show all images
  if (!window.IntersectionObserver) {
    return (el) => {
      el.classList.add('mosaicPopup__img--load');
    };
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      entry.target.classList.add('mosaicPopup__img--load');

      const parent = entry.target.parentElement;

      // preload next out of view port if exists
      const preloadNext = [
        parent.nextElementSibling, // might be null!
        parent.nextElementSibling?.nextElementSibling,
      ];

      preloadNext.forEach((el) => {
        el?.querySelector('.mosaicPopup__img').classList.add('mosaicPopup__img--load');
      });

      observer.unobserve(entry.target);
    });
  }, {
    root: document.querySelector('.ds-modal-wrapper'),
  });

  return observer;
}
